var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobalFill = function SvgGlobalFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.045 12.9h4.93a16.1 16.1 0 0 0 2.632 7.992A9.005 9.005 0 0 1 3.045 12.9m0-1.8a9.005 9.005 0 0 1 7.562-7.992A16.1 16.1 0 0 0 7.974 11.1zm17.91 0h-4.93a16.1 16.1 0 0 0-2.632-7.992 9.004 9.004 0 0 1 7.562 7.992m0 1.8a9.004 9.004 0 0 1-7.562 7.992 16.1 16.1 0 0 0 2.633-7.992zm-11.178 0h4.446A14.3 14.3 0 0 1 12 19.733 14.3 14.3 0 0 1 9.777 12.9m0-1.8A14.3 14.3 0 0 1 12 4.268a14.3 14.3 0 0 1 2.223 6.832z"
  })));
};
export default SvgGlobalFill;